module.exports = __webpack_public_path__ + "static/media/open-in-browser.29fc73d3.png";